// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1cgFw","title":"FrontImage_title__1vhcX"};